module.exports = __webpack_public_path__ + "static/media/1 封面.f251566d.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/伯爵茶司康/1 封面.JPG
// module id = 232
// module chunks = 0